import React, { useContext, useState } from 'react'
import TitleContext from '../../TitleContext'
import { useTranslation } from 'react-i18next'
import { Page } from '../Elements/PageMargins'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import UserScreeningTab from './UserScreeningTab'
import { useAuth } from '../Routes/AuthProvider'
import NoPermission from '../Elements/NoPermission'

enum ScreeningTabEnum {
  UserScreening = 'userScreening',
}

const LegalLayout = (): React.JSX.Element => {
  const { t } = useTranslation()
  const { featureAbility } = useAuth()
  const { useTitleEffect } = useContext(TitleContext)

  const title = t('Legal.Title', 'Ministry safe')

  useTitleEffect(title)
  const hasFeatureBackgroundCheck = featureAbility.can(
    'backgroundCheck',
    'Feature'
  )
  const [selectedTab, setSelectedTab] = useState(ScreeningTabEnum.UserScreening)

  const userScreeningTabTitle = t(
    'LegalLayout.Tab.Title.Legal',
    'User Screening'
  )

  const message = t(
    'LegalLayout.NoPermission.message',
    `You don't have permission to view this page.`
  )

  const userScreeningTab = (
    <Tab
      label={userScreeningTabTitle}
      value={ScreeningTabEnum.UserScreening}
      key={userScreeningTabTitle}
    />
  )

  const tabs = [userScreeningTab]

  const updateSelectedTab = (tabKey: string) => {
    switch (tabKey) {
      case ScreeningTabEnum.UserScreening:
        setSelectedTab(ScreeningTabEnum.UserScreening)
        break
    }
  }

  return (
    <>
      {hasFeatureBackgroundCheck ? (
        <TabContext value={selectedTab}>
          <TabList
            value={selectedTab}
            onChange={(_, newValue) => updateSelectedTab(newValue)}
            textColor="primary"
          >
            {tabs}
          </TabList>
          <TabPanel value={ScreeningTabEnum.UserScreening}>
            <Page withinTab>
              <UserScreeningTab />
            </Page>
          </TabPanel>
        </TabContext>
      ) : (
        <NoPermission content={message} />
      )}
    </>
  )
}

export default LegalLayout
